var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeclinedCrossWarning = function SvgDeclinedCrossWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90.43,
    height: 87.009,
    viewBox: "0 0 90.43 87.009",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18856",
    "data-name": "Group 18856",
    transform: "translate(-676.746 -429.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Warning_911852",
    transform: "translate(957.445 614.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17741",
    "data-name": "Group 17741",
    transform: "translate(-214.997 -185.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17740",
    "data-name": "Group 17740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M12.37,0a1.86,1.86,0,0,0-1.613.95L.262,19.286a1.92,1.92,0,0,0,0,1.921,1.854,1.854,0,0,0,1.623.95h20.97a1.854,1.854,0,0,0,1.623-.95,1.944,1.944,0,0,0,0-1.921L13.983.95A1.86,1.86,0,0,0,12.37,0Zm0,1.167a.808.808,0,0,1,.647.372l10.5,18.346a.774.774,0,0,1,0,.723.836.836,0,0,1-.657.382H1.885a.821.821,0,0,1-.657-.382.774.774,0,0,1,0-.723l10.5-18.346A.808.808,0,0,1,12.37,1.167Zm0,4.958A.576.576,0,0,0,11.8,6.7v8.161a.578.578,0,0,0,.568.589.57.57,0,0,0,.558-.589V6.7A.567.567,0,0,0,12.37,6.126Zm0,10.5a.874.874,0,1,0,.836.868A.859.859,0,0,0,12.37,16.621Z",
    transform: "translate(-0.004 0)",
    fill: "#ff6a65"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18605",
    "data-name": "Group 18605",
    transform: "translate(629.879 164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_verified_1983696",
    transform: "translate(46.867 284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M73,43.819a11.31,11.31,0,0,1,0-8.678l.385-.913a11.409,11.409,0,0,0-6.23-14.92l-.846-.381a11.2,11.2,0,0,1-6.23-6.166L59.774,12A11.768,11.768,0,0,0,44.621,5.835l-.769.3a11.849,11.849,0,0,1-8.846,0l-.692-.3a11.656,11.656,0,0,0-15,6.242l-.308.609a11.2,11.2,0,0,1-6.23,6.166l-.692.3a11.437,11.437,0,0,0-6.153,14.92l.308.685a11.31,11.31,0,0,1,0,8.678l-.308.837a11.236,11.236,0,0,0,6.23,14.844l.769.3a11.2,11.2,0,0,1,6.23,6.166l.385.837a11.536,11.536,0,0,0,15,6.242l.846-.381a11.849,11.849,0,0,1,8.846,0l.692.3A11.614,11.614,0,0,0,60,66.427l.308-.609a11.2,11.2,0,0,1,6.23-6.166l.615-.228a11.32,11.32,0,0,0,6.23-14.92ZM36.39,54.1h0l-15-12.484,4.615-5.4L35.544,44.2,52.389,24.408l5.461,4.567L36.39,54.1Z",
    transform: "translate(-5.033 -4.988)",
    fill: "#ff6a65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18593",
    "data-name": "Group 18593",
    transform: "translate(62.739 302.594)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9165",
    "data-name": "Rectangle 9165",
    width: 38,
    height: 31,
    transform: "translate(0.382 0.406)",
    fill: "#ff6a65"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Cross_2180907",
    transform: "translate(3.373 3.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18592",
    "data-name": "Group 18592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10932",
    "data-name": "Path 10932",
    d: "M34.761,26.722,44.866,19l5.657,4.353L40.457,31.045l10.065,7.722L44.866,43.09,34.761,35.4,24.7,43.09,19,38.767l10.1-7.722L19,23.353,24.7,19Z",
    transform: "translate(-19 -19)",
    fill: "#f4f4f4",
    fillRule: "evenodd"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeclinedCrossWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/declinedCrossWarning.07e3cb74.svg";
export { ForwardRef as ReactComponent };